import { render, staticRenderFns } from "./OfferVarConfiguration.vue?vue&type=template&id=51f8522e&scoped=true"
import script from "./OfferVarConfiguration.vue?vue&type=script&lang=js"
export * from "./OfferVarConfiguration.vue?vue&type=script&lang=js"
import style0 from "./OfferVarConfiguration.vue?vue&type=style&index=0&id=51f8522e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51f8522e",
  null
  
)

export default component.exports